<template>
	<input
		v-model="displayVal"
		:type="type"
		:id="inputId || 'INPUT_' + _uid"
		:autocomplete="autocomplete"
		:class="[
			'text-gray-900 shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full border-gray-300 rounded-md',
			markInvalid
				? 'text-red-500 border-red-500 border-2 bg-red-100 shadow-sm focus:text-gray-900'
				: '',
			disabled ? 'text-gray-500 bg-gray-100' : '',
		]"
		:disabled="disabled"
		@blur="onBlur"
	/>
</template>

<script>
export default {
	props: {
		value: {
			required: true,
		},
		type: {
			type: String,
			default: "text",
		},
		autocomplete: {
			type: String,
			default: "on",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		markInvalid: {
			type: Boolean,
			default: false,
		},
		inputId: {
			type: String,
		},
		dp: {
			type: Number,
			default: null,
		},
		maxValue: {
			type: Number,
			default: null,
			required: false,
		},
		showZeroValue: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	data() {
		let decimalSeparator = this.locale == "de" ? "," : ".",
			val = this.value
				? "" + this.value
				: this.showZeroValue && this.value == "0"
				? this.value
				: "";

		return {
			decimalSeparator: decimalSeparator,
			val: val,
			displayVal: this.dp === null ? val : val.replace(".", decimalSeparator),
		};
	},
	methods: {
		maybeCompleteDecimalPlaces() {
			if (this.dp === null || this.displayVal == "") {
				return;
			}
			let pieces = this.displayVal.split(this.decimalSeparator);
			if (pieces.length == 1) {
				pieces.push("0".repeat(this.dp));
			} else if (pieces[1].length < this.dp) {
				pieces[1] = pieces[1] + "0".repeat(this.dp - pieces[1].length);
			} else {
				pieces[1] = pieces[1].substr(0, this.dp);
			}
			this.displayVal =
				this.dp == 0 ? pieces[0] : pieces.join(this.decimalSeparator);
		},
		notifyInputChange() {
			this.val = this.displayVal.replace(this.decimalSeparator, ".");
			this.$emit("input", this.val);
			this.$emit("change");
		},
		onBlur() {
			this.maybeCompleteDecimalPlaces();
			this.notifyInputChange();
		},
	},
	watch: {
		displayVal(v) {
			/*this.val = v.replace(this.decimalSeparator, '.');
            this.$emit('input', this.val);
            this.$emit('change');*/
			if (this.maxValue !== null && parseInt(v) > this.maxValue) {
				this.displayVal = this.maxValue;
			}
		},
	},
};
</script>
